
import type { SVGProps } from 'react';
const SvgDone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#done_svg__a)">
      <path
        fill="#263E6A"
        d="m9.55 17.308-4.97-4.97.714-.713 4.256 4.256 9.156-9.156.713.713z"
      />
    </g>
    <defs>
      <clipPath id="done_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDone;
